/* Folders */
const AUTH_FOLDER = "https://cartpe.s3.ap-south-1.amazonaws.com/Authentication+Images/";
const CARTPE_FOLDER = "https://cartpe.s3.ap-south-1.amazonaws.com/CartPe+Images/";
const MISCELLANEOUS_FOLDER = "https://cartpe.s3.ap-south-1.amazonaws.com/Miscellaneous+Images/";
const ORDERS_FOLDER = "https://cartpe.s3.ap-south-1.amazonaws.com/Orders/";
const CUSTOMER_SERVICE_FOLDER =
    "https://cartpe.s3.ap-south-1.amazonaws.com/Customer+Service+Images/";

/* CartPe images */
export const CARTPE_ICON = CARTPE_FOLDER + "cartpe-icon.png";
export const CARTPE_LOGO = CARTPE_FOLDER + "cartpe-logo.png";
export const CARTPE_LOGO_BLACK =
    CARTPE_FOLDER + "cartpe-high-resolution-logo-black-transparent.svg";
export const CARTPE_ICON_BLACK = CARTPE_FOLDER + "cartpe-favicon-black.png";

/* Home Screen images */
export const HOME_SCREEN_IMAGE =
    "https://cartpe.s3.ap-south-1.amazonaws.com/Home+Screen/home_screen.jpg";

/* Authentication images */
export const LOGIN_USER_IMAGE = AUTH_FOLDER + "login.png";
export const REGISTER_USER_IMAGE = AUTH_FOLDER + "register.jpg";
export const EMAIL_VERIFICATION_FAILURE_IMAGE = AUTH_FOLDER + "email-verify-failure.jpg";
export const EMAIL_VERIFICATION_SUCCESS_IMAGE = AUTH_FOLDER + "email-verify-success.jpg";
export const RESET_PASSWORD_CONFIRM_IMAGE = AUTH_FOLDER + "reset-password-confirm.jpg";
export const RESET_PASSWORD_IMAGE = AUTH_FOLDER + "reset-password.jpg";
export const CHANGE_PASSWORD_IMAGE = AUTH_FOLDER + "change_password.jpg";

/* Miscellaneous images */
export const PLACEHOLDER_IMAGE = MISCELLANEOUS_FOLDER + "placeholder.jpg";
export const BAD_REQUEST_400 = MISCELLANEOUS_FOLDER + "400_bad_request.jpg";
export const NOT_FOUND_404 = MISCELLANEOUS_FOLDER + "404_not_found.jpg";
export const EDIT_PROFILE_IMAGE = MISCELLANEOUS_FOLDER + "edit_profile.jpg";

/* Orders images */
export const PAYMENT_FAILED_IMAGE = ORDERS_FOLDER + "payment_failed.jpg";
export const ORDER_CONFIRMED = ORDERS_FOLDER + "order_confirmed.jpg";

/* Customer Service images */
export const CONTACT_US_IMAGE = CUSTOMER_SERVICE_FOLDER + "contact_us.jpg";
